import { TrueBase, css, html } from "../TrueBase/TrueBase";

import { buttonStyles } from "../TrueButton/TrueButton";

/**
 * @customelement - true-link
 * @description
 * Component used for links
 */
export class TrueLink extends TrueBase {
  static get properties() {
    return {
      isButton: {
        type: Boolean,
      },
      isBlock: {
        type: Boolean,
      },
      smoothScroll: {
        type: Boolean,
        reflect: false,
      },
      smoothScrollOffset: {
        type: Number,
      },
      active: {
        type: Boolean,
      },
      isLoading: {
        type: Boolean,
      },
    };
  }

  constructor() {
    super();
    this.smoothScrollOffset = 50;
  }

  _smoothScroll(event) {
    if (this.smoothScroll) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
      const links = this.shadowRoot.querySelectorAll("slot");
      const linkNodes = links[0]
        .assignedNodes()
        .filter((n) => n.nodeName === "A");
      const targetID = linkNodes[0].getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (targetAnchor) {
        event.preventDefault();
        const originalTop = distanceToTop(targetAnchor);

        window.scrollBy({
          top: originalTop - this.smoothScrollOffset,
          left: 0,
          behavior: "smooth",
        });
      }
    }
  }

  render() {
    return html` <slot @click="${this._smoothScroll}"></slot> `;
  }

  static get styles() {
    return [
      super.styles,
      buttonStyles,
      css`
        :host {
          display: var(--link-display, inline-flex);
        }

        :host([isBlock]) {
          display: block;
        }

        ::slotted(a) {
          color: var(--link-color, var(--link-default-color, #000));
          text-decoration: var(--link-text-decoration, none);
          font-family: var(--link-font-family, inherit);
          font-size: var(--link-font-size, 1em);
          transition: var(--transition, all 0.3s ease);
          display: var(--link-display, inline-flex);
          align-items: center;
        }

        :host([active]) ::slotted(a) {
          color: var(--link-active-color, blue);
          border-bottom: var(--link-active-border-bottom, 1px solid blue);
        }

        :host(:hover) ::slotted(a) {
          color: var(--link-hover-color, blue);
        }
      `,
    ];
  }
}

window.customElements.get("true-link") ||
  window.customElements.define("true-link", TrueLink);
